import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <p>© 2024 Druma.ai. All rights reserved.</p>
    </footer>
  );
};

export default Footer;
